import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Heart } from '@phosphor-icons/react';
import { productsAPI, formatApiError } from '../../services/api';
import { toast } from 'sonner';

export function TipJarSection({ product, productId, isAuthenticated, formatCurrency, navigate }) {
  const [tipAmount, setTipAmount] = useState('');
  const [tipMessage, setTipMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSendTip = async () => {
    if (!isAuthenticated) { toast.error('Please login to contribute'); navigate('/login'); return; }
    const amount = parseFloat(tipAmount);
    if (isNaN(amount) || amount <= 0) { toast.error('Enter a valid amount'); return; }
    setSending(true);
    try {
      await productsAPI.contribute(productId, amount, tipMessage);
      toast.success(`Tipped ${formatCurrency(amount)}!`);
      setTipAmount('');
      setTipMessage('');
    } catch (error) { toast.error(formatApiError(error)); }
    finally { setSending(false); }
  };

  return (
    <Card className="mt-4 bg-[#0D1F17] border border-[#22C55E]/20 rounded-sm shadow-none" data-testid="tip-section">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <Heart className="w-5 h-5 text-[#22C55E]" weight="fill" />
          <span className="text-sm font-bold text-white">Leave a Tip</span>
        </div>
        <div className="space-y-3">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#999999]">$</span>
            <Input type="number" step="1" min="1" placeholder={product.price?.toString() || '5'} value={tipAmount} onChange={(e) => setTipAmount(e.target.value)} className="rounded-sm bg-[#111111] border-[#333333] text-white pl-8 h-12" data-testid="tip-amount-input" />
          </div>
          <Input placeholder="Leave a message (optional)" value={tipMessage} onChange={(e) => setTipMessage(e.target.value)} className="rounded-sm bg-[#111111] border-[#333333] text-white text-sm h-10" data-testid="tip-message-input" />
          <Button onClick={handleSendTip} disabled={sending} className="w-full bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-sm h-11 font-semibold" data-testid="send-tip-button">
            <Heart className="w-4 h-4 mr-2" weight="fill" />
            {sending ? 'Sending...' : 'Send Tip'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
